// extracted by mini-css-extract-plugin
export var formContainer = "_lf-0";
export var message = "_lf-1";